// extracted by mini-css-extract-plugin
export default {"overlay":"TapTextBox_overlay__yc-u5","tapText":"TapTextBox_tapText__k-ORd"};